export const CSV_READ_ERROR = 'Не удалось прочитать файл';

// Excel на Windows часто сохраняет CSV в windows-1251, а не в UTF-8.
// Признак неверной кодировки — символ замены U+FFFD после декодирования.
const decode = (buffer: ArrayBuffer): string => {
  const utf8 = new TextDecoder('utf-8').decode(buffer);

  if (!utf8.includes('�')) {
    return utf8;
  }

  try {
    return new TextDecoder('windows-1251').decode(buffer);
  } catch {
    return utf8;
  }
};

export const readCsvFile = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => reject(new Error(CSV_READ_ERROR));
    reader.onload = () => {
      const result = reader.result;

      if (result instanceof ArrayBuffer) {
        resolve(decode(result));
        return;
      }

      reject(new Error(CSV_READ_ERROR));
    };

    reader.readAsArrayBuffer(file);
  });
